<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" />
    <HelloWorld msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
// @ is an alias to /src
import Api from "@/api";
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",

  components: {
    HelloWorld
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getUsers(() => {
        //
      });
    });
  },

  methods: {
    getUsers() {
      const endpoint = this.$partnerEndpoint("users");

      Api()
        .get(endpoint)
        .then(response => {
          console.log(response.status);
          this.$router.push({
            name: "UsersOverview"
          });
        })
        .catch(response => {
          console.log(response.status);
        });
    }
  }
};
</script>
